import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { CollapseType } from '@meitu/saas-editor-ui/es/types';

export interface ICollapseModel {
    /**
     * 当前面板类型
     */
    currentType: CollapseType | null;

    /**
     * 当前真实渲染的面板类型
     */
    actualType: CollapseType | null;

    /**
     * 设置当前面板类型
     */
    setCurrentType: (payload: CollapseType | null) => void;

    /**
     * 获取当前面板类型
     */
    getCurrentType: () => CollapseType | null;

    /**
     * 设置当前面板类型为空
     */
    destroy: () => void;

    /**
     * 设置当前真实渲染的面板类型
     */
    setActualType: (payload: CollapseType | null) => void;

    /**
     * 同时设置当前面板类型和真实渲染的面板类型
     */
    setBothType: (payload: CollapseType | null) => void;
}

const useCollapseModel = create<ICollapseModel>()(
    immer((set, get) => ({
        currentType: null,

        actualType: null,

        destroy: () =>
            set((state) => {
                state.currentType = null;
            }),

        setCurrentType: (payload) =>
            set((state) => {
                state.currentType = payload;
            }),

        getCurrentType: () => get().currentType,

        setActualType: (payload) =>
            set((state) => {
                state.actualType = payload;
            }),

        setBothType: (payload) =>
            set((state) => {
                state.currentType = payload;
                state.actualType = payload;
            }),
    })),
);

export { useCollapseModel };
export const getCollapseModel = () => useCollapseModel.getState();
